import React from "react";
import { useSearchParams } from "react-router-dom";
import AdminMobileConcerns from "../AdminMobileMode/AdminMobileConcerns";

export default function PropertyManagementSecurity() {
  const [searchParams, setSearchParams] = useSearchParams();

  const type = searchParams.get("type") || "all";

  return <div>{type === "Concerns" && <AdminMobileConcerns />}</div>;
}
